export enum RoleEnum {
    Doctor = 'Doctor',
    App = 'App'
}